import List from "@/components/list";
import { tableBaseProps } from "@/utils/common.js";

const Table = (args) => {
  const { edit, del, toDetail } = args.listeners;

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    const dealConf = [
      [
        "icon-edit",
        "编辑自习室组",
        () => {
          edit(item);
        },
        "classRoomGroup:update",
      ],
      // [
      //   item.isRemoveBtn ? "icon-delete" : "icon-delete-disable",
      //   "删除",
      //   () => {
      //     item.isRemoveBtn && del(item);
      //   },
      //   "",
      // ],
      [
        "icon-delete",
        "删除",
        () => { del(item) },
        "classRoomGroup:delete",
      ],
    ];

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const RoomName = ({ props: { vo } }) => {
    const roomItem = vo.row;
    return (
      <div class="base-hover-char" onClick={() => toDetail(roomItem)}>
        {roomItem.roomGroupName}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      ...tableBaseProps("自习室组名称", "roomName", "", false,),
      render: (vo) => <RoomName vo={vo} />
    },
    
    tableBaseProps("创建时间", "createDate", "240"),
  ];

  AccountTableConfig.push({
    label: "操作",
    fixed: "right",
    width: 150,
    render: (vo) => <Deal vo={vo} />,
  });

  return (
    <List
      {...args}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
